import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';
import { GuardProps } from 'types';
import { useEffect } from 'react';
import return_to from 'utils/route-guard/return_to';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { isLoggedIn,isMfa } = useAuth();
 
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
         if(isLoggedIn && !isMfa){
            navigate(`/user/account-profile/profile2`);
        }
        else  if (isLoggedIn){
            let redir = true;
             const path_parts = location.pathname.split('/').filter((p) => p.length > 0);
             const external_paths = ['mediaplanconfirmation','clientaccess'];
             
             if(path_parts.length > 0 && external_paths.includes(path_parts[0].toLowerCase())){
                redir = false;
             }
             if(redir) {
                navigate(return_to.path_get_e({search: location.search}) || DASHBOARD_PATH, { replace: true });
             }
        }
       
        
    }, [isLoggedIn,isMfa, navigate]);

    return children;
};

export default GuestGuard;
